goog.provide('el8.app.settings.sortSettings');

goog.require('el8.app.settings.reactTab');

el8.app.settings.sortSettings = el8.app.settings.reactTab({
  containerId: 'sortSettings',
  renderFnName: 'renderSortSettings'
});